import React from "../../_snowpack/pkg/react.js";
export function Sep(props) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, " • ");
}
export function DashSep(props) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, " – ");
}
